import { render } from "./OurPricing.vue?vue&type=template&id=174076ae&scoped=true"
import script from "./OurPricing.vue?vue&type=script&lang=js"
export * from "./OurPricing.vue?vue&type=script&lang=js"

import "./OurPricing.vue?vue&type=style&index=0&id=174076ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-174076ae"

export default script